<template>
    <div class="password-reset">
        <div class="title">Check you email</div>
        <div class="text">
            Instructions for resetting your password have been sent to your email address {{email}}
        </div>
        <div class="text">
            If it doesn't arrive soon, check your spam, junk, and promotion folders or <span class="link" @click="resendRequest">send the email again</span>
        </div>
        <div class="text">
            Need help? <a href="https://www.ppcshield.io/support/" class="link">Contact support</a>.
        </div>
        <div v-if="sendAgain !== ''" class="text">
            <span v-if="sendAgain === 'ok'" style="color: green;">
                ✔️ An email has been sent again
            </span>
            <span v-else style="color: red;">
                {{sendAgain}}
            </span>
        </div>
        <div class="back-to-login"><a class="link" href="https://client.ppcshield.io/login">Back to Login</a></div>
    </div>
</template>

<script>
    export default {
        props: ['email'],
        data(){
            return {
                sendAgain: '',
            }
        },
        methods: {
            resendRequest(){
                this.send()
                    .then(info => {
                        this.sendAgain = 'ok';
                    })
                    .catch(err => {
                        Object.keys(err.response.data?.errors).forEach((key) => {
                            this.sendAgain = err.response.data?.errors[key][0];
                        })
                        console.log('err', err);
                    });
            },
            send(){
                return axios.post('/password/sendResetMail', {email: this.email});
            }
        },
        mounted() {
            this.send()
                .catch(err => {
                    Object.keys(err.response.data?.errors).forEach((key) => {
                        this.sendAgain = err.response.data?.errors[key][0];
                    })
                    console.log('err', err);
                });
        }
    }
</script>
